import { ProfitAnalysisPage } from "../../_shared/ProfitAnalysisPage";

export default function SoldCreatePage() {
  return <ProfitAnalysisPage paType="sold" mode="create" />;
}
